import { Link } from 'react-router-dom';

export function EarlyAccessDisclaimer() {
  return (
    <div style={{
      minHeight: '100dvh',
      background: '#f9fafb',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 24px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
    }}>
      <div style={{ maxWidth: 560, width: '100%' }}>
        <span style={{
          display: 'inline-block',
          background: '#fef3c7',
          color: '#92400e',
          fontSize: 11,
          fontWeight: 700,
          padding: '4px 10px',
          borderRadius: 20,
          letterSpacing: '0.05em',
          textTransform: 'uppercase',
          marginBottom: 20,
        }}>
          Early Access
        </span>

        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#111827', margin: '0 0 16px' }}>
          Platform Disclaimer
        </h1>

        <p style={{ fontSize: 16, color: '#374151', lineHeight: 1.75, margin: '0 0 24px' }}>
          Housewizrd is currently in early access while we build and improve the platform.
          We help connect homeowners with contractors but do not guarantee contractor work
          quality or outcomes. License and insurance verification reflects an automated check
          as of the date shown on each contractor's profile â€” please verify independently
          before hiring. Your feedback during this period helps shape what we build next.
        </p>

        <p style={{ fontSize: 14, color: '#6b7280', margin: '0 0 32px' }}>
          Have feedback?{' '}
          <a
            href="mailto:feedback@housewizrd.com"
            style={{ color: '#9333EA', textDecoration: 'none', fontWeight: 600 }}
          >
            feedback@housewizrd.com
          </a>
        </p>

        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
          <Link to="/privacy" style={{ fontSize: 13, color: '#9333EA', textDecoration: 'none' }}>
            Privacy Policy
          </Link>
          <Link to="/terms" style={{ fontSize: 13, color: '#9333EA', textDecoration: 'none' }}>
            Terms of Service
          </Link>
          <Link to="/" style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none' }}>
            â† Back to Housewizrd
          </Link>
        </div>
      </div>
    </div>
  );
}
